<template>
  <svg
    id="document"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g id="Group_905" data-name="Group 905" transform="translate(9.351)">
      <g id="Group_904" data-name="Group 904">
        <path
          id="Path_432"
          data-name="Path 432"
          d="M302.044,2.732a1.4,1.4,0,0,0-.412-.994L300.306.412a1.438,1.438,0,0,0-1-.412h-.081V2.812h2.822V2.732Z"
          transform="translate(-299.222)"
        />
      </g>
    </g>
    <g id="Group_907" data-name="Group 907">
      <g id="Group_906" data-name="Group 906">
        <path
          id="Path_433"
          data-name="Path 433"
          d="M8.56,9.673a1.881,1.881,0,0,1,.45-.731L12.185,5.78V3.75H8.891a.456.456,0,0,1-.454-.469V0H1.406A1.408,1.408,0,0,0,0,1.406V14.594A1.408,1.408,0,0,0,1.406,16h9.36a1.419,1.419,0,0,0,1.419-1.406V11.1l-.515.5a1.864,1.864,0,0,1-.729.45l-1.49.5-.227.012a1.172,1.172,0,0,1-1.111-1.544ZM2.344,8.437H7.016a.469.469,0,1,1,0,.937H2.344a.469.469,0,1,1,0-.937ZM1.875,7.031a.468.468,0,0,1,.469-.469H7.016a.469.469,0,1,1,0,.937H2.344A.468.468,0,0,1,1.875,7.031Zm0,3.75a.468.468,0,0,1,.469-.469H7.016a.469.469,0,1,1,0,.937H2.344A.468.468,0,0,1,1.875,10.781Zm7.016,2.344a.469.469,0,1,1,0,.937H6.078a.469.469,0,1,1,0-.937Zm-6.547-7.5a.469.469,0,1,1,0-.937H8.891a.469.469,0,0,1,0,.937Z"
        />
      </g>
    </g>
    <g id="Group_909" data-name="Group 909" transform="translate(8.989 10.088)">
      <g id="Group_908" data-name="Group 908">
        <path
          id="Path_434"
          data-name="Path 434"
          d="M288.083,322.808l-.408,1.223a.234.234,0,0,0,.3.3l1.223-.408Z"
          transform="translate(-287.663 -322.808)"
        />
      </g>
    </g>
    <g id="Group_911" data-name="Group 911" transform="translate(9.963 6.228)">
      <g id="Group_910" data-name="Group 910">
        <path
          id="Path_435"
          data-name="Path 435"
          d="M321.907,199.307l-3.087,3.087,1.331,1.331,3.087-3.087Z"
          transform="translate(-318.82 -199.307)"
        />
      </g>
    </g>
    <g id="Group_913" data-name="Group 913" transform="translate(13.713 4.623)">
      <g id="Group_912" data-name="Group 912">
        <path
          id="Path_436"
          data-name="Path 436"
          d="M440.83,148.209a.979.979,0,0,0-1.33,0l-.681.681,1.331,1.331.681-.681A.944.944,0,0,0,440.83,148.209Z"
          transform="translate(-438.819 -147.949)"
        />
      </g>
    </g>
    <g id="Group_916" data-name="Group 916" transform="translate(15.725 6.206)">
      <g id="Group_915" data-name="Group 915">
        <g id="Group_914" data-name="Group 914">
          <path
            id="Path_437"
            data-name="Path 437"
            d="M503.215,198.811h0l0,0Z"
            transform="translate(-503.215 -198.802)"
          />
          <path
            id="Path_438"
            data-name="Path 438"
            d="M503.3,198.679l0,0Z"
            transform="translate(-503.3 -198.673)"
          />
          <path
            id="Path_439"
            data-name="Path 439"
            d="M503.436,198.6Z"
            transform="translate(-503.429 -198.602)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "document-icon",
};
</script>

<style scoped></style>
